import React from 'react';
import { createBrowserRouter,  RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import OtpVerify from '../routes/OtpVerify';
import SubscriptionPage from '../routes/Subscriptionpage';
import SubscriptionInProcess from '../routes/SubscriptionInProcess';
import LoginPage from '../routes/LoginPage';


const Routing = () => {
    
    const router = createBrowserRouter([{
        path:"/home",
        element:<HomePage />
    },
    {
        path:"/category/:category_name",
        element:<CategoryPage />
    },
    {
        path:"/category/video/play",
        element:<CategoryVideoPlay />
    },
    {
        path:"/",
        element:<HomePage />
    },{
        path:"/otp",
        element:<OtpVerify />
    },{
        path:"/subscription-in-process",
        element:<SubscriptionInProcess />
    },{
        path:"/login",
        element:<LoginPage />
     }
     //{
    //     path:"/",
    //     element:<SubscriptionPage />
    // },
])
  
    return (
    <RouterProvider router={
        router
    } />
  )
}

export default Routing ;
